<template>
  <div
    class="specific_boost_parent_container"
    :class="[isOpen && 'opened_coupon_container']"
  >
    <div class="specific_booster_container">
      <div class="d-flex-row space-between" @click="toggleOpen">
        <div class="d-flex-row justify-start flex-5" v-if="!selectedClass">
          <p class="t-white font-family-2 bold-l t-white white-space-no">
            {{ $t("select_realm") }}
          </p>
        </div>

        <div class="d-flex-row justify-start flex-5" v-else-if="selectedClass">
          <!-- <p class="t-white regular-m white-space-no font-family-2">
            <span class="bold-m">{{ selectedClass.title }}</span> -
            {{ selectedClass.hero_class }}
          </p> -->
        </div>

        <div class="d-flex-row justify-end flex-5">
          <button @click.stop="clearClass" type="button" v-if="selectedClass">
            <CrossIcon />
          </button>
          <ChevDown />
        </div>
      </div>
    </div>

    <div
      class="booster_list_container hide_scroll cursor-pointer justify-start align-start d-flex-column gap-10"
      v-if="isOpen"
    >
      <div class="d-flex-row justify-start flex-1">
        <input-field
          :variant="'transparent'"
          :size="'small'"
          :icon-start="'SearchOutlinedIcon'"
          placeholder="Search realm"
          v-model="search"
        />
      </div>
      <div
        class="flex-1 d-flex-column justify-start align-start gap-5"
        v-for="(value, key) in filteredRealms"
        :key="value"
      >
        <div
          class="d-flex-row space-between"
          @click.prevent="itemClicked(value)"
        >
          <p class="font-family-2 t-white medium-l white-space-no">
            {{ value?.title }} -
            <span class="t-light font-family-2 regular-s">{{
              value?.server?.title
            }}</span>
          </p>
          <!-- <Checkbox
            :is-checked="checkoutStore.realms?.includes(value?.id)"
            type="custom"
          /> -->
          <RadioButton :checked="checkoutStore.realms?.includes(value?.id)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import RadioButton from "~/components/custom/RadioButton.vue";
import ChevDown from "~/components/icons/ChevDown.vue";
import InputField from "~/components/custom/InputField.vue";
import CrossIcon from "~/components/icons/CrossIcon.vue";
import Checkbox from "~/components/custom/Checkbox.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();
const { currentGameSlug } = useGameComposable();
const search = ref("");
const { getLocale } = useFunctions();
const isOpen = ref(false);

const toggleOpen = () => {
  isOpen.value = !isOpen.value;
};
const closeOutside = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const itemClicked = (value) => {
  //   console.log(value);
  try {
    checkoutStore.setRealms(value.id);
  } catch (error) {
    console.log(error);
  }
};

const selectedClass = computed(() => {
  return null;
});

const realms = ref([]);

const fetchGetMmoRealms = async () => {
  const server = checkoutStore.getSelectedServer?.value;
  try {
    const { data: realmResponse } = await useApiFetch(
      "/api/get-mmo-game-realms",
      {
        method: "POST",
        fetchKey: "get-mmo-game-realms",
        body: {
          locale: getLocale(),
          game: "world-of-warcraft-boost",
          server: server,
        },
      }
    );
    if (realmResponse.value.data.realms) {
      realms.value = realmResponse.value.data.realms;
    }
  } catch (error) {
    console.log(error);
  }
};

const filteredRealms = computed(() => {
  if (search.value) {
    // filteredHeroes = filteredHeroes.filter((hero) => {
    //   return (
    //     hero.title?.toLowerCase().includes(search.value.toLowerCase()) ||
    //     hero.hero_class?.toLowerCase().includes(search.value.toLowerCase())
    //   );
    // });

    return realms.value.filter((real) => {
      return real.title?.toLowerCase()?.includes(search.value);
    });
  }
  return realms.value;
});

fetchGetMmoRealms();

watch(
  checkoutStore.getSelectedServer,
  () => {
    realms.value = [];
    fetchGetMmoRealms();
  },
  {
    deep: true,
  }
);
</script>
